// extracted by mini-css-extract-plugin
export default {"modal":"PhoneModal_modal__C7NYC","title":"PhoneModal_title__AGVS1","loader":"PhoneModal_loader__8hxCq","image":"PhoneModal_image__azKPG"};